/* eslint-disable max-len */
import React, { useState } from 'react'
import CustomeDatePicker from '../../../../components/DatePicker'
import moment from 'moment';
import ImageSizeTooltip from '../../../../components/ProfileImageUpload/imageSizeTooltip'
import { HandleInputChange } from '../../../../components/InputFeld/inputChange';
import { countWords } from '../../../../CommonMethods/WordCount';

export default function TransactionData({
    state,
    setToastErrorMessage,
    setsubmitSelected,
    submitSelected,
    setErrorMessage,
    setState,
    dateError,
    setdateError,
    AccountType,
    referenceNumberError,
    setReferenceNumberError,
    disableDate = false
}) {
    const [descriptionLength, setDescriptionLength] = useState(false)
    /**
     * The function `handleSelectedDate` checks if a selected date is within a specified range and
     * updates the state accordingly, while also handling error cases.
     */
    const handleSelectedDate = (id, date, dateString) => {
        // setHandleFieldError("")
        setdateError("")
        setsubmitSelected(false)
        setToastErrorMessage("")
        // Parse the selected date string
        const selectedDate = moment.utc(dateString); // Parse as UTC
        const startDate = moment.utc(JSON.parse(localStorage.getItem('FY_details')).start_date); // Parse as UTC
        let endDate = (new Date(JSON.parse(localStorage.getItem('FY_details')).end_date) < new Date(moment.utc().startOf('day'))) ? JSON.parse(localStorage.getItem('FY_details')).end_date : moment.utc().startOf('day');
        // let endDate = moment.utc().startOf('day'); // Set to the start of today in UTC
        // let endDate = moment.utc(JSON.parse(localStorage.getItem('FY_details')).end_date); // Set to the start of today in UTC

        // Parse the start_date string
        if (selectedDate.isSameOrAfter(startDate) && selectedDate.isSameOrBefore(endDate)) {
            // The selected date is after or equal to the start date, so update the state
            setState((prev) => ({
                ...prev,
                [id]: dateString,
            }));
        } else {
            // The selected date is before the start date, so throw an error
            // setHandleFieldError(id)
            setState((prev) => ({
                ...prev,
                [id]: "",
            }));
            setdateError("date-error")
            setToastErrorMessage(`Transaction Date must be within the ${`${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})`}`);
            // You can also set an error message in the state if needed.
        }
    };
    /**
     * The function `handleOnchangeInput` is used to handle the change event of an input field in a
     * React component.
     */
    const handleOnchangeInput = (e) => {
        setToastErrorMessage("")
        setsubmitSelected(false)
        setDescriptionLength(false)
        if (e.target.id === "description") {
            const words = e.target.value?.split(" ");
            if (words.length <= 100) {
                setState((prv) => ({
                    ...prv,
                    ["description"]: e.target.value.split(' ').slice(0, 100).join(' ')
                }))
            }
            if (words.length > 100) {
                setToastErrorMessage('Description cannot exceed 100 words')
                setDescriptionLength(true)
            } else {
                setDescriptionLength(false)
            }
        } else if (e.target.id === "reference_number") {
            setReferenceNumberError(false)
            setState((prv) => ({
                ...prv,
                ["reference_number"]: e.target.value.toUpperCase()
            }))
        }

    }

    const disabledFutureDate = (current) => {
        // Disable dates that are after the current date
        return current && current > moment().endOf('day');
    };

    const [imageSizeInfoHover, setImageSizeInfoHover] = useState(false)
    const handleImageToggle = () => {
        // Use the functional form of setState
        setImageSizeInfoHover((prevIsToggled) => !prevIsToggled);
    };

    return (
        <div className='p-3 rounded border border-[#D0D5DD] mx-auto w-[820px]'>
            <div className='flex -mx-10'>
                <div className='w-[50%] px-10'>
                    <div className='flex'>
                        <div className=' flex items-center mb-4 w-full'>
                            <label for="date_of_birth" class={`text-f7 font-normal text-[#031624] min-w-[135px] inline-flex`}>Transaction Date</label>
                            <div class="relative w-full">
                                <CustomeDatePicker
                                    setToastErrorMessage={setToastErrorMessage}
                                    setsubmitSelected={setsubmitSelected}
                                    id='transaction_date'
                                    showErrorBorder={((submitSelected && (state.transaction_date === "" || state.transaction_date === undefined || state.transaction_date === null)) || dateError === "date-error")}
                                    format="MMM DD, YYYY"
                                    state={state}
                                    placeholder="Select Transaction Date"
                                    imageClass={true}
                                    setdateError={setdateError}
                                    handleSelect={handleSelectedDate}
                                    disabledFutureDate={disabledFutureDate}
                                    disabledDate={disableDate}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='flex'>
                        <div className='flex items-center w-full'>
                            <label
                                htmlFor='item_code'
                                className='text-f7 font-normal text-[#031624] min-w-[135px] inline-flex'
                            >
                                Financial Year
                            </label>
                            <input
                                type="text"
                                value={`${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})`}
                                id="financial_year"
                                maxLength={30}
                                submitSelected={submitSelected}
                                setsubmitSelected={setsubmitSelected}
                                text={"Enter Financial Year"}
                                placeholder="Enter Financial Year"
                                disabled={true}
                                className={` inpt-fld error_border`}
                                style={{'width':'99%'}}
                            />
                        </div>
                    </div>
                </div>
                <div className='w-[50%] px-10'>
                    {AccountType === "journal" && <div className='flex mb-4'>
                        <div className='flex items-center w-full'>
                            <label
                                htmlFor='item_code'
                                className='text-f7 font-normal text-[#031624] min-w-[100px] inline-flex'
                            >
                                Reference #
                            </label>
                            <div className='relative'>
                                <input
                                    type="text"
                                    value={state.reference_number}
                                    id="reference_number"
                                    maxLength={30}
                                    autoComplete='off'
                                    submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                    text={"Enter Number"}
                                    placeholder="Enter Reference #"
                                    // disabled={true}
                                    onChange={(e) => handleOnchangeInput(e)}
                                    className={`${((submitSelected && state.reference_number === "") || referenceNumberError) ? "redBorder" : ""} w-[220px] inpt-fld error_border`}
                                    style={{'width':'217px'}}
                                />
                            </div>
                            <div class="relative self-end ml-2" style={{ 'top': '-8px' }}>
                                <ImageSizeTooltip
                                    handleImageToggle={handleImageToggle}
                                    imageSizeInfoHover={imageSizeInfoHover}
                                    imgtransform={'scale(1.5)'}
                                    tooltipFor={'Journal_ref_#'}
                                />
                            </div>

                        </div>
                    </div>}
                    <div className='flex'>
                        <label className="text-f7 font-normal text-[#031624] min-w-[100px] inline-flex mt-[4px]">Description</label>
                        <div className={`red-border1 rounded w-[250px]`}>
                            <textarea
                                id="description"
                                value={state.description}
                                onChange={(e) => handleOnchangeInput(e)}
                                maxlength={100}
                                className={`txt-fld w-full ${(descriptionLength && (state.description.length > 100)) ? "redBorder" : ""}`}
                                style={{'height':`${AccountType === "journal"?'40px':'85px'}`}}
                                placeholder="Enter Description"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}
